import { render, staticRenderFns } from "./TeamMembers.vue?vue&type=template&id=91ee08f4&scoped=true&"
import script from "./TeamMembers.vue?vue&type=script&lang=ts&"
export * from "./TeamMembers.vue?vue&type=script&lang=ts&"
import style0 from "./TeamMembers.vue?vue&type=style&index=0&id=91ee08f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91ee08f4",
  null
  
)

export default component.exports